module.exports = __webpack_public_path__ + "img/TV_clean_box12.0360891b.jpg";